/**
 * Preload lazy chunks và keep references để prevent garbage collection.
 * Chunks này được dùng thường xuyên nên cần giữ trong memory.
 */

// Keep references để browser không GC các chunks
const preloadedChunks: Record<string, Promise<any>> = {};

export const preloadChunks = async () => {
  // Core navigation pages - accessed frequently
  preloadedChunks.subcons = import('@/components/subcons/SubconsManagement');
  preloadedChunks.collections = import('@/components/collections/CollectionsManagement');
  
  // Project detail tabs - accessed within project context
  preloadedChunks.projectDiary = import('@/components/diary/ProjectDiary');
  preloadedChunks.specifications = import('@/components/diary/SpecificationsView');
  preloadedChunks.projectItems = import('@/components/projects/ProjectItemsManagement');
  preloadedChunks.projectTeam = import('@/components/projects/ProjectTeamManagement');
};

// Export cho testing/debugging
export const getPreloadedChunks = () => preloadedChunks;
